import { createContext, useContext, useEffect, useSyncExternalStore } from 'react';
import { Api } from '@sodamnfoolish/sjc-backend-types';
import { createStore } from '../../utils/store';
import { useBackend } from '../../Hooks/UseBackend';

const twitterUserInfoStore = createStore<Record<string, Api.Twitter.DTO.TwitterUserInfo | undefined>>({});

export const TwitterUserInfoContext = createContext(twitterUserInfoStore);

export const TwitterUserInfoProvider = ({ children }: React.PropsWithChildren) => {
    return <TwitterUserInfoContext.Provider value={twitterUserInfoStore}>{children}</TwitterUserInfoContext.Provider>;
};

export function TwitterUserInfo({
    username,
    children,
}: {
    username: string;
    children: (twitterUserInfo: Api.Twitter.DTO.TwitterUserInfo | null, isLoaded: boolean) => React.ReactElement;
}) {
    const { getTwitterUserInfoByUsername } = useBackend();

    const twitterUserInfoStore = useContext(TwitterUserInfoContext);
    const twitterUserInfoRecords = useSyncExternalStore(twitterUserInfoStore.subscribe, twitterUserInfoStore.get);

    useEffect(() => {
        if (twitterUserInfoStore.get()[username]) return;

        getTwitterUserInfoByUsername(username)
            .then((twitterUserInfo) => {
                twitterUserInfoStore.set({
                    ...twitterUserInfoStore.get(),
                    [username]: twitterUserInfo,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }, [getTwitterUserInfoByUsername, twitterUserInfoStore, username]);

    return children(twitterUserInfoRecords[username] ?? null, Boolean(twitterUserInfoRecords[username]));
}
